
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import ProductsDropdownComponent from '../products_dropdown';
import useActions from '../../hooks/useActions';
import "./subheader.scss";
import ActionTypes from '../../constants';
import { useTypedSelector } from '../../hooks/useTypedSelector';


export const SubHeader:React.FC = () => {  

    const { projectsCount } = useActions();

    const savedCount = useTypedSelector(state => state.projectsCount.saved)
    const purchasedCount = useTypedSelector(state => state.projectsCount.purchased)
    const deletedCount = useTypedSelector(state => state.projectsCount.deleted)
    const currrentTabName = useTypedSelector(state => state.currrentTabName) || ActionTypes.EMPTY
       
    useEffect(()=>{        
        projectsCount(ActionTypes.SAVED);      
        projectsCount(ActionTypes.PURCHASED);      
        projectsCount(ActionTypes.DELETED);
        //for dropdown accessibility
        // @ts-ignore
        photoOrg.Util.createMenuButtonObject('#product_links-button');
        // for touch devices not required, subheader tabs accessibility
        // @ts-ignore
        !photoOrg.Util.isTouchDevice() && photoOrg.tabNavigation.addTabListeners(".photo-Org");        
    },[])

    useEffect(()=>{
        updateGlobalHeaderCount();

    },[savedCount, purchasedCount])

    

    const manageClassNames = (e) => {
        let currentClickedElement = e.currentTarget;
        var state = currentClickedElement.getAttribute('type');
        //For desktop subheader
        var subHeaderWrapperEle = document.getElementsByClassName("projecttabs-desktop")[0]
        var previousActiveElement = subHeaderWrapperEle.getElementsByClassName("active")[0];
        previousActiveElement.classList.remove("active"); 
        var currentEle = subHeaderWrapperEle.getElementsByClassName(currentClickedElement.classList[0])[0]             
        currentEle.classList.add("active");
        //For mobile subheader
        var subHeaderMobileEle = document.getElementsByClassName("projecttabs-mobile")[0]
        var previousActiveMobileElement = subHeaderMobileEle.getElementsByClassName("active")[0];
        previousActiveMobileElement.classList.remove("active"); 
        currentEle = subHeaderMobileEle.getElementsByClassName(currentClickedElement.classList[0])[0]             
        currentEle.classList.add("active");
        //@ts-ignore
        photoOrg.Util.trackLinksAndButtons(state+ " projects",'projectsPage');
    }

     //Updating the projects count in global header Div.
    const updateGlobalHeaderCount = () =>{
        try{
            let globalHeaderCountDiv;
            let deviceHeaderCountDiv;
            if(document.querySelectorAll(".new-global-header").length > 0){
                //@ts-ignore
                globalHeaderCountDiv = $($('#globalHeaderMyProjects').find('span')[1]);
                //@ts-ignore
                //A separate div is used for mobile, So we should update the mobile div as well.
                deviceHeaderCountDiv = $($('#deviceHeaderMyProjects').find('span')[1]);
            }else{
                //@ts-ignore
                globalHeaderCountDiv = $($('#globalHeaderMyProjects').find('span')[0]);
                //@ts-ignore
                deviceHeaderCountDiv = $($('#deviceHeaderMyProjects').find('span')[0]);
            }
            if(globalHeaderCountDiv){
                var count = savedCount + purchasedCount;
                if(!Number.isNaN(count)){
                    globalHeaderCountDiv.text('('+count+')')
                    deviceHeaderCountDiv.text('('+count+')')
                    }
            }
        }catch(e){}
      }

    
    return (
    <div className="sub-header-wrapper projects-subheader-wrapper full">
        <div className="row projects-subheader">
           <div className="left-subheader-wrapper">
            <ul className="prject-tabs projecttabs-desktop disableClick" role="tablist">
                {/** @ts-ignore */}
            <li type="saved" className={`saved desktop ${(currrentTabName === ActionTypes.SAVED || currrentTabName === ActionTypes.EMPTY) ? "active" : "" } `}  onClick={manageClassNames}>
                <Link role = "tab" tabIndex="0" to="/saved">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["saved"]["saved_desktop"] } <span className="project_saved_count">({savedCount})</span>
                </Link>
            </li>
            {/** @ts-ignore */}
            <li className={`purchased desktop ${ currrentTabName === ActionTypes.PURCHASED ?  "active" : ""}` } type="purchased" onClick={manageClassNames}>
                <Link role = "tab" tabIndex="-1" to="/purchased">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["purchased"]["purchased_desktop"] } <span className="project_purchased_count">({purchasedCount})</span>
                </Link>
            </li>
            {/** @ts-ignore */}
            <li className={`deleted desktop ${ currrentTabName === ActionTypes.DELETED ? "active" : ""} `} type="deleted" onClick={manageClassNames}>
                <Link role = "tab" tabIndex="-1" to="/deleted">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["deleted"]["deleted_desktop"] } <span className="project_deleted_count">({deletedCount})</span>
                </Link>
            </li>
            </ul>
            {/** @ts-ignore */}
            <h1>{  photoOrg.translations.projects["projects"]["my_projects"] }</h1>

        </div>
           <div className="right-subheader-wrapper">
            <ul className="rectangle shadow">
                {/** @ts-ignore */}
                <li className="single" onClick={photoOrg.Util.trackLinksAndButtons('New Project','projectsPage')}>
                    {/** @ts-ignore */}
                    <div role="menuitem" className="projects_text" tabIndex="0" id="product_links-button" name="projects_text" data-dropdown="hoverproducts" href="<%- photoOrg.config.store_url %>/shop" aria-haspopup="true" aria-controls="hoverproducts" aria-expanded="false"><span className="desktop">{ photoOrg.translations.projects["new_project"] }</span><span className="mobile">{ photoOrg.translations.projects["new"] }</span></div>
                </li>
            </ul>
        </div>
        <ProductsDropdownComponent/>
        </div>
        <ul className="prject-tabs projecttabs-mobile disableClick" role="tablist">
            {/** @ts-ignore */}
            <li type="saved" className="saved mobile active" onClick={manageClassNames}>
                <Link to="/saved">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["saved"]["saved_mobile"] } <span className="project_saved_count">({savedCount})</span>
                </Link>
            </li>
            {/** @ts-ignore */}
            <li className="purchased mobile" type="purchased" onClick={manageClassNames}>
                <Link to="/purchased">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["purchased"]["purchased_mobile"] } <span className="project_purchased_count">({purchasedCount})</span>
                </Link>
            </li>
            {/** @ts-ignore */}
            <li className="deleted mobile" type="deleted" onClick={manageClassNames}>
                <Link to="/deleted">
                    {/** @ts-ignore */}
                    {  photoOrg.translations.projects["projects"]["deleted"]["deleted_mobile"] } <span className="project_deleted_count">({deletedCount})</span>
                </Link></li>
        </ul>
        {/** @ts-ignore */}
        <div className="tap_message"><span>{photoOrg.translations.projects["projects"]["tap_on_project"]}</span></div>
    </div>)
}

export default SubHeader;

// const mapStateToProps = ({projectsCount,currrentTabName}) => {
//     return {
//         // savedCount : projectsCount.saved,
//         // purchasedCount : projectsCount.purchased,
//         //deletedCount : projectsCount.deleted  ,
//         //currrentTabName:   currrentTabName
//     }
// }

//export default connect(mapStateToProps,{projectsCount})(SubHeader);
